export enum AppointmentsPathsEnum {
  ROOT = "appointments",
}

export enum AppointmentsRoutesEnum {
  ROOT = "/appointments",
}
